<template>
  <div id="c19declarationreport">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">Covid-19 Declaration Report</h3>
        </div>
        <div class="col-lg-7">
          <div class="row">
            <button v-on:click="getReport()" class="btn btn-primary float-right">Generate</button>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="c19declarationreportListInt.length < 1">
          <strong>{{ startupText }}</strong>
          <img src="../assets/notfound.png" />
        </div>
        <div v-if="c19declarationreportListInt.length > 0" class="datatable_group ClassAttendanceReportPage">
          <el-button type="primary" round @click="exportExcel()" class="btnExport"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Export</el-button>

          <data-tables :data="c19declarationreportListInt">
            <el-table-column
              v-for="c19declarationreportListInfo in c19declarationreportList"
              :prop="c19declarationreportListInfo.prop"
              :label="c19declarationreportListInfo.label"
              :key="c19declarationreportListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'

export default {
  name: 'c19declarationreport',
  data() {
    return {
      startupText: 'No Records...',
      c19declarationreportListInt: [],
      c19declarationreportList: [
        {
          prop: 'CONname',
          label: 'Name',
        },
        {
          prop: 'CONEmail',
          label: 'Email',
        },
        {
          prop: 'ParCovDclRemark',
          label: 'Remark',
        },
        {
          prop: 'ParCovDclCancelRemark',
          label: 'Cancel Remark',
        },
        {
          prop: 'ParCovDclStatus',
          label: 'Status',
        },
        {
          prop: 'ParCovDclCreatedOn_convert',
          label: 'Date',
        },
      ],
    }
  },
  async created() {},
  methods: {
    async getReport() {
      try {
        this.c19declarationreportListInt = []

        const response = await DataSource.shared.getParentCovidDeclarationReport()

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('Get Parent Covid DeclarationReport Error!')
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'No Record Found!',
            })
          } else {
            this.c19declarationreportListInt = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    exportExcel() {
      let exportExcelObject = []

      this.c19declarationreportListInt.forEach(m => {
        let tempExportExcelObject = {
          Name: m['CONname'],
          Email: m['CONEmail'],
          Remark: m['ParCovDclRemark'],
          'Cancel Remark': m['ParCovDclCancelRemark'],
          Status: m['ParCovDclStatus'],
          Date: m['ParCovDclCreatedOn_convert'],
        }

        exportExcelObject.push(tempExportExcelObject)
      })

      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'Covid-19 Declaration Report.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>

<style scoped>
.btnExport {
  display: block;
}
</style>

<style></style>
